import axios from 'axios';
import React from 'react';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import * as ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'rxjs';
import App from './App';
import configureStore from './core-module/redux/store';
import './index.css';

const Redux = configureStore();
Redux.store.subscribe(listener);

function listener() {
  let token = Redux.store.getState().auth.user.id;
  if (Redux.store.getState().auth.isLoggedIn) {
    axios.defaults.params = {};
    axios.defaults.headers.common['Authorization'] = token;
    axios.defaults.headers['Content-Type'] = 'application/json';
    axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
  }
}

const queryClient = new QueryClient();

ReactDOM.render(
  <PersistGate loading={null} persistor={Redux.persistor}>
    <QueryClientProvider client={queryClient}>
      <Provider store={Redux.store}>
        <App />
      </Provider>
    </QueryClientProvider>
  </PersistGate>,
  document.getElementById('root') as HTMLElement
);
